import { BrowserRouter, Link, Route, Routes, useNavigate } from "react-router";
import Header from "./components/header";
import Login from "./components/login";
import Bottom from "./components/bottom";
import Aboutus from "./components/aboutus";
import Home from "./components/home";
import './bgppl.css';
import { Analytics } from '@vercel/analytics/react';
import emailContext from './components/emailcontext'; 
import articleContext from "./components/articlecontext";
import { useState, useEffect } from "react";
import Allarticles from "./components/allarticles";
import Article from "./components/articlelayout";
import Addarticle from "./components/addarticle";
import AcadassocPagecs from "./components/acadassoc_cs";
import AcadassocPageeee from "./components/acadassoc_eee";
import AcadassocPageeni from "./components/acadassoc_eni";
import AcadassocPageece from "./components/acadassoc_ece";
import CsaElectionPres from "./components/csaelection_pres";
import CsaElectionVicePres from "./components/csaelection_vicepres";
import CsaElectionGenSec from "./components/csaelection_gensec";
import CsaElectionSportsSec from "./components/csaelection_sportssec";
import CsaElectionGirlsConvener from "./components/csaelection_girlsconvener";
import CsaElectionTreasurer from "./components/csaelection_treasurer";
import CsaElectionNota from "./components/csaelection_nota";
import CsaElectionPhdRep from "./components/csaelection_phdrep";

function App() {
  const navigate = useNavigate();
  const[dpdwn,setDpdwn]=useState(false);
  const[email,setEmail]=useState();
  const[artdata,setArtdata]=useState([]);

  useEffect(() => {
    const navEntries = window.performance.getEntriesByType("navigation");
    const isReload = navEntries.length > 0 && navEntries[0].type === "reload";

    if (isReload && window.location.pathname !== "/") {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (<articleContext.Provider value={[artdata,setArtdata]}> <emailContext.Provider value={[email,setEmail]}> <div className="bgppl">
    <Header dpdwn={dpdwn} setDpdwn={setDpdwn}/>
    {/* <div style={{display:dpdwn?"flex":"none"}}className="drpdwn"><Link to={"/acads"}>comp sci</Link></div> */}
    
      <Routes>

        <Route path='/add_article' element={<Addarticle/>}></Route>
        <Route path='/all_articles' element={<Allarticles/>}></Route>
        <Route path='/login' element={<Login/>}/>
        <Route path='/about_us' element={<Aboutus/>}/>
        <Route path='/' element={<Home/>}/>
        <Route path='/article/:artid' element={<Article/>}/>
        <Route path='/acadassoc_cs' element={<AcadassocPagecs/>}/>
        <Route path='/acadassoc_eee' element={<AcadassocPageeee/>}/>
        <Route path='/acadassoc_eni' element={<AcadassocPageeni/>}/>
        <Route path='/acadassoc_ece' element={<AcadassocPageece/>}/>
        <Route path='/csaelection_pres' element={<CsaElectionPres/>}/>
        <Route path='/csaelection_vicepres' element={<CsaElectionVicePres/>}/>
        <Route path='/csaelection_gensec' element={<CsaElectionGenSec/>}/>
        <Route path='/csaelection_sportssec' element={<CsaElectionSportsSec/>}/>
        <Route path='/csaelection_girlsconvener' element={<CsaElectionGirlsConvener/>}/>
        <Route path='/csaelection_treasurer' element={<CsaElectionTreasurer/>}/>
        <Route path='/csaelection_nota' element={<CsaElectionNota/>}/>
        <Route path='/csaelection_phdrep' element={<CsaElectionPhdRep/>}/>
    </Routes>
    
    <Bottom/>
    <Analytics />
  </div></emailContext.Provider>
 </articleContext.Provider>
 
  );
}

export default App;
